const semanticClassNames = {
  root: 'vertical-menu',
  menuItem: 'vertical-menu__item',
  subMenu: 'vertical-menu__submenu',
  menuItemLabel: 'vertical-menu__item-label',
} as const;

export default semanticClassNames;
